



















































































import { Component, Vue } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useFiservCodeMappingStore } from "@/admin/store/fiservCodeMapping";
import { FiservCodeMappingRequest, FiservCodeMappingResponse, FiservCodeType } from "@/admin/types";

@Component
export default class FiservCodeMappings extends Vue {
    selectedCodeType: FiservCodeType = FiservCodeType.HsaServiceFee;
    codeTypeOptions = Object.entries(FiservCodeType).map(([key, value]) => ({
        key,
        value
    }));
    fiservCodeMappingStore = useFiservCodeMappingStore();
    rolePermissionStore = useRolePermissionsStore();
    newMapping: FiservCodeMappingRequest = {
        code: "",
        startValue: 0,
        tier: 0,
        type: this.selectedCodeType
    };
    editMapping?: FiservCodeMappingResponse = null;

    mounted (): void {
        this.fiservCodeMappingStore.getFiservCodeMappings();
    }

    get hasFiservCodeMappingsPermission (): boolean {
        return this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalFiservCodeMappingsEdit);
    }

    get selectedMappings (): FiservCodeMappingResponse[] {
        return this.fiservCodeMappingStore.mappings.filter(x => x.type === this.selectedCodeType);
    }

    get hasTier (): boolean {
        return this.selectedCodeType === FiservCodeType.TierRate || this.selectedCodeType === FiservCodeType.TierAPY || this.selectedCodeType === FiservCodeType.TierRange;
    }

    get hasEndValue (): boolean {
        return this.selectedCodeType === FiservCodeType.TierRange;
    }

    addNewMapping (): void {
        this.newMapping.type = this.selectedCodeType;
        this.fiservCodeMappingStore.createFiservCodeMapping(this.newMapping).then(x => {
            this.newMapping = {
                code: "",
                startValue: 0,
                tier: 0,
                type: this.selectedCodeType
            };
        });
    }

    beginEditMapping (mapping: FiservCodeMappingResponse): void {
        this.editMapping = mapping;
    }
    endEditMapping (): void {
        this.editMapping = null;
    }
    deleteMapping (mapping: FiservCodeMappingResponse): void {
        this.fiservCodeMappingStore.deleteFiservCodeMapping(mapping.fiservCodeMappingId);
    }
    saveMapping (): void {
        this.fiservCodeMappingStore.updateFiservCodeMapping(this.editMapping.fiservCodeMappingId, this.editMapping).then(x => {
            this.editMapping = null;
        });
    }

}

